import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import FeatureManagementApi from "../../Classes/API/FeatureManagementApi";

const AddFeatureModal = ({ open, onClose, onSuccess }) => {
  const [newFeature, setNewFeature] = useState({
    name: "",
    description: "",
    status: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!newFeature.name) return;
    setIsSubmitting(true);
    try {
      const res = await FeatureManagementApi.CreateFeature(newFeature);
      if (res.status === "Success") {
        setNewFeature({ name: "", description: "", status: false });
        onSuccess(); // Trigger context refresh
        onClose();
      }
    } catch (err) {
      console.error("Creation failed", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h5" fontWeight="700">
          Add System Feature
        </Typography>
        <Typography variant="body2" color="textSecondary">
          This feature will be propagated across all active clinic tenants.
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 3 }}>
          <TextField
            label="Feature Name (e.g., Pharmacy_Module)"
            fullWidth
            variant="filled"
            value={newFeature.name}
            onChange={(e) =>
              setNewFeature({ ...newFeature, name: e.target.value })
            }
          />
          <TextField
            label="Short Description"
            fullWidth
            multiline
            rows={4}
            variant="filled"
            value={newFeature.description}
            onChange={(e) =>
              setNewFeature({ ...newFeature, description: e.target.value })
            }
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={isSubmitting}
          sx={{ px: 4, borderRadius: "8px", textTransform: "none" }}
        >
          {isSubmitting ? "Deploying..." : "Create Feature"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddFeatureModal;
